import { type UseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import type { ListRecentLikersResponse } from 'generated/openapi';

import { getRecentLikersOptions } from './useGetRecentLikers.options';

const getRecentLikersKey = () => ['likes', 'recent-likers'] as const;

interface UseGetRecentLikersProps<T = ListRecentLikersResponse> {
  options?: Omit<
    UseQueryOptions<ListRecentLikersResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >;
}

export const useGetRecentLikers = <T = ListRecentLikersResponse>(
  props: UseGetRecentLikersProps<T>,
) => {
  const { options } = props;

  return useSuspenseQuery({
    ...getRecentLikersOptions<T>(),
    ...options,
  });
};

useGetRecentLikers.getQueryKey = getRecentLikersKey;
